import { foldVi } from '@mt/shared';
import { Search, X } from 'lucide-react';
import { useSearchParams } from 'react-router-dom';

/** Tham số URL của ô tìm đơn ở màn Soạn hàng. */
export const PICK_SEARCH_PARAM = 'tim';

/**
 * Anh Tiến 26/10/2026 "thêm ô tìm kiếm đơn hàng tại đây": ở màn Soạn hàng, ô tìm trên cùng (chỗ "Tìm sản phẩm…") đổi thành ô tìm đơn,
 * gõ tới đâu lọc thẻ tới đó. Giữ từ khóa trên URL (?tim=) để màn Soạn hàng đọc, mở lại / tải lại không mất.
 */
export function PickSearchBox() {
  const [params, setParams] = useSearchParams();
  const value = params.get(PICK_SEARCH_PARAM) ?? '';
  const set = (v: string) =>
    setParams(
      (p) => {
        const n = new URLSearchParams(p);
        if (v) n.set(PICK_SEARCH_PARAM, v);
        else n.delete(PICK_SEARCH_PARAM);
        return n;
      },
      { replace: true },
    );
  return (
    <label className="flex h-10 min-w-0 flex-1 items-center gap-2 rounded-lg border bg-card px-3 text-sm focus-within:border-primary sm:max-w-lg">
      <Search className="size-4 shrink-0 text-muted-foreground" />
      <input
        type="search"
        value={value}
        onChange={(e) => set(e.target.value)}
        placeholder="Tìm đơn: số phiếu, số đơn, khách, mã hàng…"
        aria-label="Tìm đơn soạn hàng"
        className="min-w-0 flex-1 bg-transparent outline-none placeholder:text-muted-foreground [&::-webkit-search-cancel-button]:hidden"
        data-testid="pick-search"
      />
      {value && (
        <button type="button" onClick={() => set('')} aria-label="Xóa tìm" className="text-muted-foreground hover:text-foreground">
          <X className="size-4" />
        </button>
      )}
    </label>
  );
}

/** Khớp không dấu, mọi từ gõ vào đều phải có (số phiếu, số đơn, khách, mã / tên hàng, biển số, tài xế, địa chỉ). */
export function pickMatches(
  r: {
    code: string;
    orderCode: string;
    customerName: string;
    vehiclePlate: string | null;
    driverName: string | null;
    deliveryAddress: string | null;
    lines: { productCode: string; productName: string }[];
  },
  q: string,
): boolean {
  const words = foldVi(q).split(' ').filter(Boolean);
  if (!words.length) return true;
  const hay = foldVi(
    [r.code, r.orderCode, r.customerName, r.vehiclePlate, r.driverName, r.deliveryAddress, ...r.lines.flatMap((l) => [l.productCode, l.productName])].join(' '),
  );
  const compact = hay.replace(/ /g, '');
  return words.every((w) => hay.includes(w) || compact.includes(w));
}
